import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { AUTH_MANAGE_API } from "../constants/constants";
import { defaultErrorMsg, defaultHeaders } from "../utils/params";

export const authServiceApi = createApi({
  reducerPath: "authEmployeeApi",
  baseQuery: async (args, api, extraOptions) => {
    const baseQuery = fetchBaseQuery({
      baseUrl: AUTH_MANAGE_API,
      prepareHeaders: async (headers, { getState }) => {
        const token = (getState() as any)?.auth?.access_token;

        return defaultHeaders(headers, token);
      },
    });

    const result = await baseQuery(args, api, extraOptions);

    await defaultErrorMsg(result);

    return result;
  },
  tagTypes: [
    "GetMe",
    "GetAllJobPost",
    "GetSingleJobPost",
    "GetAllSurveyTemplate",
    "GetSurveyTemplateDetails",
    "GetAllSurveyAnswerList",
    "GetJobAppliedList",
    "GetSingleJobApplied",
    "GetSkillList",
    "GetTagList",
    "GetSurveyData",
    "GetSurveyResponses",
    "GetSurveyResponsesByMember",
    "GetAllPayment",
    "GetAllNotification",
    "GetDashboardData",
    "GetSalarySlab",
    "GetKPIGroup",
    "GetKPI",
    "GetShift",
    "GetAttendanceSettings",
    "GetLeaveAllocation",
    "GetLeaveRequest",
    "GetJobDetails",
    "GetDailyAttendanceList",
    "GetShiftDetailsOverview",
    "GetShiftDetailsMemberOverview",
    "GetContactList",
    "GetKPIAchievement",
    "GetKPIBatch",
    "GetPayrollBatch",
    "GetCompanyWallet",
    "GetPayrollBatchSummary",
    "GetShiftMembers",
  ],
  keepUnusedDataFor: 30,
  endpoints: () => ({}),
});
